import styled from "styled-components";

import { Input } from "antd";

export const LSTextArea = styled(Input.TextArea)`
    &::placeholder {
        font-style: italic;
    }
`;
